'use client';

import dynamic from 'next/dynamic';

const Intro = dynamic(() => import('./Intro'));
const SecureTiles = dynamic(() => import('./SecureTiles'));
const OurServices = dynamic(() => import('./OurServices'));
const Questions = dynamic(() => import('./Questions'));
const PricingPlans = dynamic(() => import('./PricingPlans'));

const SecurePage = () => {
  return (
    <>
      <Intro />
      <SecureTiles />
      <OurServices />
      <PricingPlans />
      <Questions />
    </>
  );
};

export default SecurePage;
